/* =============================================================================
 * CCR UI — consent banner, mobile nav, form UX (validation, honeypot,
 * form_start / form_submit tracking), collection filters helper.
 * ========================================================================== */
(function () {
  'use strict';
  var CCR = window.CCR || (window.CCR = {});

  /* ---------- consent banner -------------------------------------------- */
  function consentBanner() {
    var banner = document.querySelector('[data-consent-banner]');
    if (!banner) return;

    function syncCheckboxes() {
      var state = CCR.consent.all();
      var a = banner.querySelector('[data-consent-analytics]');
      var m = banner.querySelector('[data-consent-ads]');
      if (a) a.checked = !!state.analytics;
      if (m) m.checked = !!state.ads;
    }

    function showBanner() {
      syncCheckboxes();
      banner.hidden = false;
    }

    function syncVisibility() {
      banner.hidden = !!CCR.consent.isDecided();
      if (!banner.hidden) syncCheckboxes();
    }
    syncVisibility();
    // Hide if Shopify hydrate / GPC decides after first paint.
    if (CCR.consent && CCR.consent.onChange) {
      CCR.consent.onChange(syncVisibility);
    }
    banner.addEventListener('click', function (e) {
      if (e.target.closest('[data-consent-accept]')) {
        CCR.consent.grantAll(); banner.hidden = true;
      }
      if (e.target.closest('[data-consent-reject]')) {
        CCR.consent.denyAll(); banner.hidden = true;
      }
      if (e.target.closest('[data-consent-save]')) {
        var a = banner.querySelector('[data-consent-analytics]');
        var m = banner.querySelector('[data-consent-ads]');
        CCR.consent.set({ analytics: !!(a && a.checked), ads: !!(m && m.checked) });
        banner.hidden = true;
      }
    });
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-consent-reopen]'),
      function (reopen) {
        reopen.addEventListener('click', function (e) {
          e.preventDefault();
          showBanner();
        });
      }
    );
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-consent-dns]'),
      function (dns) {
        dns.addEventListener('click', function (e) {
          e.preventDefault();
          if (CCR.consent.optOutSale) CCR.consent.optOutSale();
          showBanner();
        });
      }
    );
  }

  /* ---------- mobile nav ------------------------------------------------ */
  function mobileNav() {
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-nav-toggle]')) {
        var nav = document.querySelector('[data-nav]');
        if (nav) {
          var open = nav.classList.toggle('is-open');
          e.target.closest('[data-nav-toggle]').setAttribute('aria-expanded', String(open));
        }
      }
    });
  }

  /* ---------- forms: tracking, honeypot, inline validation -------------- */
  function showLeadTimingError(form) {
    var errEl = form.querySelector('[data-ccr-lead-error]');
    if (!errEl) return;
    errEl.textContent = form.getAttribute('data-ccr-too-fast') ||
      'Please take a moment to review your details, then submit again.';
    errEl.hidden = false;
  }

  function showLeadTurnstileError(form) {
    var errEl = form.querySelector('[data-ccr-lead-error]');
    if (!errEl) return;
    errEl.textContent = form.getAttribute('data-ccr-turnstile-required') ||
      'Please complete the security check, then submit again.';
    errEl.hidden = false;
  }

  function mountLeadTurnstile(form) {
    var host = form.querySelector('[data-ccr-turnstile]');
    if (!host || !CCR.turnstile || !CCR.turnstile.siteKey()) return;
    CCR.turnstile.render(host, { size: 'normal' }).catch(function () {});
  }

  function forms() {
    document.querySelectorAll('form[data-ccr-form]').forEach(function (form) {
      var started = false;
      var formStartedAt = null;
      mountLeadTurnstile(form);
      form.addEventListener('focusin', function () {
        if (!formStartedAt) formStartedAt = Date.now();
        if (!started) {
          started = true;
          CCR.track('form_start', { form_id: form.getAttribute('data-ccr-form') });
        }
      });
      form.addEventListener('submit', function (e) {
        // Honeypot: a filled hidden field => bot. Block silently.
        var hp = form.querySelector('[name="contact[website_hp]"]');
        if (hp && hp.value) { e.preventDefault(); return; }
        // Time-to-submit check: clock starts on first focusin. Faster
        // submissions (or submit with no prior focus) are treated as bots.
        var minSec = parseFloat(form.getAttribute('data-ccr-min-seconds') || '0');
        var elapsed = formStartedAt ? (Date.now() - formStartedAt) : 0;
        if (minSec > 0 && elapsed < minSec * 1000) {
          e.preventDefault();
          showLeadTimingError(form);
          CCR.track('form_submit', { form_id: form.getAttribute('data-ccr-form'), status: 'blocked_timing' });
          return;
        }
        var errClear = form.querySelector('[data-ccr-lead-error]');
        if (errClear) { errClear.hidden = true; errClear.textContent = ''; }
        if (!form.checkValidity()) {
          e.preventDefault();
          var first = form.querySelector(':invalid');
          if (first) first.focus();
          form.classList.add('was-validated');
          return;
        }

        // Unified capture: POST to the worker so the lead becomes a tagged,
        // variant-stamped Shopify customer. On failure: retry once, then show
        // error + mailto + optional contact-form inbox path (no fake thank-you).
        var endpoint = leadEndpoint();
        if (endpoint) {
          e.preventDefault();
          var turnstileHost = form.querySelector('[data-ccr-turnstile]');
          var tokenPromise = (CCR.turnstile && turnstileHost)
            ? CCR.turnstile.getToken(turnstileHost, { size: 'normal' })
            : Promise.resolve('');
          tokenPromise.then(function (token) {
            if (!token) {
              showLeadTurnstileError(form);
              return;
            }
            CCR.track('form_submit', {
              form_id: form.getAttribute('data-ccr-form'),
              landing_page_id: (form.querySelector('[name="contact[landing_page_id]"]') || {}).value || '',
              campaign: (form.querySelector('[name="contact[campaign]"]') || {}).value || '',
              offer_id: (form.querySelector('[name="contact[offer_id]"]') || {}).value || '',
              experiment_id: (form.querySelector('[name="contact[experiment_id]"]') || {}).value || '',
              channel: (form.querySelector('[name="contact[channel]"]') || {}).value || '',
              volume: (form.querySelector('[name="contact[volume]"]') || {}).value || '',
              interest: (form.querySelector('[name="contact[interest]"]') || {}).value || '',
              timeline: (form.querySelector('[name="contact[timeline]"]') || {}).value || ''
            });
            submitLeadToWorker(form, endpoint, token);
          });
          return;
        }

        CCR.track('form_submit', {
          form_id: form.getAttribute('data-ccr-form'),
          landing_page_id: (form.querySelector('[name="contact[landing_page_id]"]') || {}).value || '',
          campaign: (form.querySelector('[name="contact[campaign]"]') || {}).value || '',
          offer_id: (form.querySelector('[name="contact[offer_id]"]') || {}).value || '',
          experiment_id: (form.querySelector('[name="contact[experiment_id]"]') || {}).value || '',
          channel: (form.querySelector('[name="contact[channel]"]') || {}).value || '',
          volume: (form.querySelector('[name="contact[volume]"]') || {}).value || '',
          interest: (form.querySelector('[name="contact[interest]"]') || {}).value || '',
          timeline: (form.querySelector('[name="contact[timeline]"]') || {}).value || ''
        });
      });

      var contactFallback = form.querySelector('[data-ccr-lead-contact-fallback]');
      if (contactFallback) {
        contactFallback.addEventListener('click', function () {
          enrichContactBody(form);
          // Native submit bypasses the submit listener → shop inbox only.
          HTMLFormElement.prototype.submit.call(form);
        });
      }
    });
  }

  /* Lead endpoint = the chatbot worker's /api/lead (same worker as chat),
     derived from the runtime config island's chatbot.api_url. */
  function leadEndpoint() {
    try {
      var el = document.getElementById('ccr-runtime-config');
      if (!el) return '';
      var cfg = JSON.parse(el.textContent);
      var api = cfg && cfg.chatbot && cfg.chatbot.api_url;
      if (!api) return '';
      return api.replace(/\/api\/chat\/?$/, '/api/lead');
    } catch (e) { return ''; }
  }

  function fieldVal(form, name) {
    var el = form.querySelector('[name="' + name + '"]');
    return el ? el.value : '';
  }

  function selectLabel(form, name) {
    var el = form.querySelector('[name="' + name + '"]');
    if (!el || !el.options || el.selectedIndex < 0) return fieldVal(form, name);
    return el.options[el.selectedIndex].text || el.value;
  }

  function buildLeadPayload(form, turnstileToken) {
    var experiments = {};
    try {
      if (CCR.experiments && CCR.experiments.activeAssignments) {
        experiments = CCR.experiments.activeAssignments();
      }
    } catch (e) {}
    return {
      name: fieldVal(form, 'contact[name]'),
      email: fieldVal(form, 'contact[email]'),
      company: fieldVal(form, 'contact[company]'),
      phone: fieldVal(form, 'contact[phone]'),
      channel: fieldVal(form, 'contact[channel]'),
      volume: fieldVal(form, 'contact[volume]'),
      interest: fieldVal(form, 'contact[interest]'),
      timeline: fieldVal(form, 'contact[timeline]'),
      message: fieldVal(form, 'contact[body]'),
      website_hp: fieldVal(form, 'contact[website_hp]'),
      marketing_consent: !!(form.querySelector('[name="contact[marketing_consent]"]') || {}).checked,
      landing_page_id: fieldVal(form, 'contact[landing_page_id]'),
      campaign_id: fieldVal(form, 'contact[campaign]'),
      offer_id: fieldVal(form, 'contact[offer_id]'),
      client_id: CCR.clientId || '',
      experiments: experiments,
      utm: CCR.utm || {},
      landing: window.location.pathname,
      turnstile_token: turnstileToken || ''
    };
  }

  function postLead(endpoint, payload) {
    return fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (!res.ok) {
        var err = new Error('lead endpoint ' + res.status);
        err.status = res.status;
        throw err;
      }
      return res;
    });
  }

  function enrichContactBody(form) {
    var body = form.querySelector('[name="contact[body]"]');
    if (!body) return;
    var utm = CCR.utm || {};
    var bits = [
      body.value ? body.value.trim() : '',
      '--- Lead details ---',
      'Channel: ' + selectLabel(form, 'contact[channel]'),
      'Volume: ' + selectLabel(form, 'contact[volume]'),
      'Interest: ' + selectLabel(form, 'contact[interest]'),
      'Timeline: ' + selectLabel(form, 'contact[timeline]'),
      'Landing page id: ' + fieldVal(form, 'contact[landing_page_id]'),
      'Campaign: ' + fieldVal(form, 'contact[campaign]'),
      'Offer: ' + fieldVal(form, 'contact[offer_id]'),
      'Path: ' + window.location.pathname,
      'UTM: ' + [utm.utm_source, utm.utm_medium, utm.utm_campaign].filter(Boolean).join(' / ')
    ].filter(Boolean);
    body.value = bits.join('\n');
  }

  function buildMailto(form) {
    var subject = encodeURIComponent('White-label inquiry — ' + (fieldVal(form, 'contact[company]') || fieldVal(form, 'contact[name]') || 'website'));
    var lines = [
      'Name: ' + fieldVal(form, 'contact[name]'),
      'Email: ' + fieldVal(form, 'contact[email]'),
      'Company: ' + fieldVal(form, 'contact[company]'),
      'Channel: ' + selectLabel(form, 'contact[channel]'),
      'Volume: ' + selectLabel(form, 'contact[volume]'),
      'Interest: ' + selectLabel(form, 'contact[interest]'),
      'Timeline: ' + selectLabel(form, 'contact[timeline]'),
      '',
      fieldVal(form, 'contact[body]')
    ];
    return 'mailto:wholesale@theorycoffee.com?subject=' + subject +
      '&body=' + encodeURIComponent(lines.join('\n'));
  }

  function showLeadFailure(form) {
    var panel = form.querySelector('[data-ccr-lead-fallback]');
    var errEl = form.querySelector('[data-ccr-lead-error]');
    var mail = form.querySelector('[data-ccr-lead-mailto]');
    if (mail) mail.setAttribute('href', buildMailto(form));
    if (panel) panel.hidden = false;
    if (errEl) {
      errEl.hidden = true;
      errEl.textContent = '';
    }
    CCR.track('form_submit', {
      form_id: form.getAttribute('data-ccr-form'),
      status: 'worker_failed'
    });
  }

  function setLeadPending(form, on) {
    var pending = form.querySelector('[data-ccr-lead-pending]');
    if (pending) pending.hidden = !on;
  }

  function submitLeadToWorker(form, endpoint, turnstileToken) {
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;
    setLeadPending(form, true);
    var payload = buildLeadPayload(form, turnstileToken);
    var fallback = form.querySelector('[data-ccr-lead-fallback]');
    if (fallback) fallback.hidden = true;

    // No automatic retry: Turnstile tokens are single-use. On failure, reset
    // the widget so the visitor can complete a fresh check and submit again.
    postLead(endpoint, payload).then(function () {
      setLeadPending(form, false);
      showFormSuccess(form);
    }).catch(function () {
      if (btn) btn.disabled = false;
      setLeadPending(form, false);
      var host = form.querySelector('[data-ccr-turnstile]');
      if (CCR.turnstile && host) CCR.turnstile.reset(host);
      showLeadFailure(form);
    });
  }

  function showFormSuccess(form) {
    CCR.track('lead_captured', { source: 'lead_form' });
    window.location.href = form.getAttribute('data-redirect-url') ||
      '/pages/whitelabel-thank-you';
  }

  /* ---------- hydrate hidden campaign/UTM fields on any lead form ------- */
  function hydrateHiddenFields() {
    var utm = CCR.utm || {};
    document.querySelectorAll('form[data-ccr-form]').forEach(function (form) {
      setVal(form, 'contact[source]', utm.utm_source);
      setVal(form, 'contact[medium]', utm.utm_medium);
      setVal(form, 'contact[campaign]', utm.utm_campaign, true);
      setVal(form, 'contact[utm_term]', utm.utm_term);
      setVal(form, 'contact[utm_content]', utm.utm_content);
      setVal(form, 'contact[client_id]', CCR.clientId);
      // experiment id: first running experiment scoped to this form, if any
      var expId = form.getAttribute('data-ccr-experiment');
      if (expId && CCR.experiments) {
        setVal(form, 'contact[experiment_id]', expId);
        var v = CCR.experiments.assign(expId);
        setVal(form, 'contact[experiment_variant]', v);
      }
    });
    function setVal(form, name, value, onlyIfEmpty) {
      var el = form.querySelector('[name="' + name + '"]');
      if (el && value != null && (!onlyIfEmpty || !el.value)) el.value = value;
    }
  }

  /* ---------- declarative tracking ------------------------------------- *
   * CSP-safe replacement for one-off inline scripts: any element with
   * [data-ccr-track="<event>"] (optionally [data-ccr-payload='<json>']) fires
   * once on load. Used by the thank-you page and lead-form success state.    */
  function autoTrack() {
    document.querySelectorAll('[data-ccr-track]').forEach(function (el) {
      var evt = el.getAttribute('data-ccr-track');
      var payload = {};
      try { payload = JSON.parse(el.getAttribute('data-ccr-payload') || '{}'); } catch (e) {}
      CCR.track(evt, payload);
      var adsConversion = el.getAttribute('data-ccr-ads-conversion');
      if (adsConversion && CCR.consent && CCR.consent.has('ads') &&
        typeof window.gtag === 'function') {
        window.gtag('event', 'conversion', { send_to: adsConversion });
      }
      if (el.hasAttribute('data-ccr-meta-lead') && typeof window.fbq === 'function') {
        window.fbq('track', 'Lead');
      }
      var shopifyTrack = el.getAttribute('data-ccr-shopify-track');
      if (shopifyTrack && window.ShopifyAnalytics && window.ShopifyAnalytics.lib) {
        var shopifyPayload = {};
        try { shopifyPayload = JSON.parse(el.getAttribute('data-ccr-shopify-payload') || '{}'); } catch (e) {}
        window.ShopifyAnalytics.lib.track(shopifyTrack, shopifyPayload);
      }
    });
  }

  CCR.ready(function () {
    consentBanner();
    mobileNav();
    forms();
    hydrateHiddenFields();
    autoTrack();
  });
})();
